/* eslint-disable quotes */
export const faqs = [
  {
    category: 'generalEnquiries',
    icon: '/images/icon_32_generalinquiries.png',
    faqs: [
      {
        question: 'faqGeneral.q1',
        answer: 'faqGeneral.a1'
      },
      {
        question: 'faqGeneral.q2',
        answer: 'faqGeneral.a2'
      },
      {
        question: 'faqGeneral.q3',
        answer: 'faqGeneral.a3'
      },
      {
        question: 'faqGeneral.q4',
        answer: 'faqGeneral.a4'
      },
      {
        question: 'faqGeneral.q5',
        answer: 'faqGeneral.a5'
      },
      {
        question: 'faqGeneral.q6',
        answer: 'faqGeneral.a6'
      },
      {
        question: 'faqGeneral.q7',
        answer: 'faqGeneral.a7'
      },
      // {
      //   question: 'faqGeneral.q8',
      //   answer: 'faqGeneral.a8'
      // },
      // {
      //   "question": "faqGeneral.q9",
      //   "answer": "faqGeneral.a9"
      // },
      {
        question: 'faqGeneral.q10',
        answer: 'faqGeneral.a10'
      },
      {
        question: 'faqGeneral.q11',
        answer: 'faqGeneral.a11'
      },
      {
        question: 'faqGeneral.q12',
        answer: 'faqGeneral.a12'
      },
      {
        question: 'faqGeneral.q13',
        answer: 'faqGeneral.a13'
      }
    ]
  },
  {
    category: 'bookingProcess',
    icon: '/images/icon_32_bookingprocess.png',
    faqs: [
      {
        question: 'faqBooking.q1',
        answer: 'faqBooking.a1'
      },
      {
        question: 'faqBooking.q2',
        answer: 'faqBooking.a2'
      },
      {
        question: 'faqBooking.q3',
        answer: 'faqBooking.a3'
      },
      {
        question: 'faqBooking.q4',
        answer: 'faqBooking.a4'
      },
      {
        question: 'faqBooking.q5',
        answer: 'faqBooking.a5'
      },
      {
        question: 'faqBooking.q6',
        answer: 'faqBooking.a6'
      }
    ]
  },
  {
    category: 'cancellation',
    icon: '/images/icon_32_cancellations.png',
    faqs: [
      {
        question: 'faqCancellation.q1',
        answer: 'faqCancellation.a1'
      },
      {
        question: 'faqCancellation.q2',
        answer: 'faqCancellation.a2'
      },
      {
        question: 'faqCancellation.q3',
        answer: 'faqCancellation.a3'
      },
      {
        question: 'faqCancellation.q4',
        answer: 'faqCancellation.a4'
      },
      {
        question: 'faqCancellation.q5',
        answer: 'faqCancellation.a5'
      }
    ]
  },
  {
    category: 'paymentProcess',
    icon: '/images/icon_32_payment.png',
    faqs: [
      {
        question: 'faqPayment.q1',
        answer: 'faqPayment.a1'
      },
      {
        question: 'faqPayment.q2',
        answer: 'faqPayment.a2'
      },
      {
        question: 'faqPayment.q3',
        answer: 'faqPayment.a3'
      },
      {
        question: 'faqPayment.q4',
        answer: 'faqPayment.a4'
      }
    ]
  },
  {
    category: 'insurance',
    icon: '/images/icon_32_insurance.png',
    faqs: [
      {
        question: 'faqInsurance.q1',
        answer: 'faqInsurance.a1'
      }
    ]
  }
];
